import React from "react";
import Products from "../../components/assets/Products";

const ProductsManagementPage = () => {
  return (
    <>
      <Products />
    </>
  );
};

export default ProductsManagementPage;
